import styled from "styled-components";

export const WrapperYelum = styled.div`
  @media (min-width: 767px) {
    .form-default .form-row > [class*="col-"] {
      padding-right: 20px;
    }
  }
`;
